import { loadStyle } from 'components/storefront/editor/easyblocks-page/parser/utils';
import { getAttributeValue } from './utils';

/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

/**
 * @param {AssetLoader} assetLoader
 */
function processStyle(assetLoader) {
  return {
    selector: 'style',
    remove: true,
    processNode(node) {
      const hash = getAttributeValue(node, 'data-hash');
      const content = node.innerHTML;

      const loader = loadStyle(hash, content);

      if (loader) {
        assetLoader.addContentAsset(loader);
      }
    },
  };
}

export default processStyle;
